import { PatientsDirectory } from "@/components/patients/PatientsDirectory";
import { PatientProfile } from "@/components/settings/PatientProfile";
import { useParams } from "react-router-dom";

const Patients = () => {
  const { patientId, tab } = useParams<{
    patientId?: string;
    tab?: "overview" | "profile-intake" | "patient-records" | "comms";
  }>();

  return (
    <div className="flex h-full overflow-hidden bg-background p-2 sm:p-3">
      <div className="flex-1 min-h-0 min-w-0 overflow-hidden">
        {patientId ? (
          <PatientProfile
            patientId={patientId}
            tab={
              tab === "overview" ||
              tab === "profile-intake" ||
              tab === "patient-records" ||
              tab === "comms"
                ? tab
                : "overview"
            }
          />
        ) : (
          <PatientsDirectory />
        )}
      </div>
    </div>
  );
};

export default Patients;
